// 图片前缀
const imgUrl = process.env.VUE_APP_API + "/uploads/"

export {
    imgUrl
}